import { render } from "./NavigationBar.vue?vue&type=template&id=5ba44a65&scoped=true&ts=true"
import script from "./NavigationBar.vue?vue&type=script&lang=ts"
export * from "./NavigationBar.vue?vue&type=script&lang=ts"

import "./NavigationBar.vue?vue&type=style&index=0&id=5ba44a65&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba44a65"]])

export default __exports__